export default "__VITE_ASSET__CLdGGoxf__"